import { useEffect, useState } from "react";
import Carousel from "../../controls/carousel";
import { IoIosArrowBack } from "react-icons/io";
import { ICaseStudy } from "../cases";

export interface IProjectPage {
  category: string;
  title: string;
}

const ProjectPage = ({ category, title }: IProjectPage) => {
  const [caseStudy, setCaseStudy] = useState<ICaseStudy | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(encodeURI(`${category}data.json`), {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data: ICaseStudy[]) => {
        const match = data.find((c) => c.title === title);
        if (match) {
          setCaseStudy(match);
        } else {
          setNotFound(true);
        }
      })
      .catch(() => setNotFound(true));
  }, [category, title]);

  return (
    <section className="min-h-screen">
      <div className="max-w-5xl mx-4 lg:mx-auto pt-10 pb-20">
        <a
          href={`#${category}`}
          className="inline-flex items-center gap-1 text-h-gold uppercase tracking-[0.15em] text-sm hover:opacity-70"
        >
          <IoIosArrowBack size={18} /> Back to {category}
        </a>
        <h1 className="text-h-gold text-3xl lg:text-5xl font-normal uppercase tracking-[0.2em] text-center pt-8 pb-2">
          {title}
        </h1>
        <p className="text-h-gold text-center uppercase tracking-[0.3em] text-xs pb-10">
          {category}
        </p>
        {caseStudy ? (
          <Carousel slides={caseStudy.images}></Carousel>
        ) : notFound ? (
          <p className="text-h-gold text-center pt-10">
            This project could not be found.{" "}
            <a href={`#${category}`} className="underline">
              Back to {category}
            </a>
          </p>
        ) : null}
      </div>
    </section>
  );
};

export default ProjectPage;
